<template>
  <div class="gw1034m-container">
    <div class="sensor-view">
      <gwSensorView :sensorList="sensorList" :realDataObj="realDataObj" />
    </div>

    <div class="map-view">
      <bmapView style="height: 500px" :res="realDataObj" />
    </div>
  </div>
</template>

<script>
import gwSensorView from '@/components/gwSensor/index.vue';
import bmapView from '../GW1021/components/BMapGL/index.vue';
import { toBmapPos2 } from '@/utils/bmapUtil';

import { isEmpty } from '@/utils/is';

export default {
  name: 'GW1034M-device',
  computed: {
    sn() {
      return this.$attrs.sn || this.$route.params.sn;
    }
  },

  sockets: {
    '/socket/basic'(res) {
      if (res.sn !== this.sn) return;
      if (isEmpty(res)) return;

      let positionArr = toBmapPos2({ coordinate: [res.longitude, res.latitude] });

      Object.assign(this.realDataObj, res);
      this.realDataObj.longitude = positionArr[0];
      this.realDataObj.latitude = positionArr[1];
    }
  },
  components: {
    gwSensorView,
    bmapView
  },

  data() {
    return {
      disableNotice: true,
      sensorList: [
        {
          name: 'α表面污染水平',
          prop: 'alphaValue',
          unitName: 'Bq/cm²'
        },
        {
          name: 'β表面污染水平',
          prop: 'betaValue',
          unitName: 'Bq/cm²'
        },
        {
          name: '检测时间',
          prop: 'testTime'
        }
      ],
      realDataObj: {
        testTime: '',
        alphaValue: '',
        betaValue: '',
        longitude: 0,
        latitude: 0
      }
    };
  },
  mounted() {},

  methods: {}
};
</script>

<style lang="scss">
.gw1034m-container {
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  gap: 20px;
  .map-view,
  .sensor-view {
    width: 50%;
  }

  .sensor-view {
    .el-row {
      margin-bottom: 10px;
      .grid-content {
        height: 150px;
        border: 1px solid rgb(96, 118, 173);
        margin-bottom: 20px;
        .sensor-info {
          //   text-align: center;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          .name,
          .unit {
            font-size: 18px;
          }
          .value {
            color: #00e401;
            font-size: 22px;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
